module.exports = __webpack_public_path__ + "static/theo-companies-johnst@2x-4356b1b70dff3ce2e5bb7c7e312cfa94.png";